import { render, staticRenderFns } from "./EditBay.vue?vue&type=template&id=b8fe7a60&"
import script from "./EditBay.vue?vue&type=script&lang=js&"
export * from "./EditBay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports